import { NormalEdge, NoEdge, YesEdge } from "../components/edges";

export const edgeTypes = {
	normalEdge: NormalEdge,
	yesEdge: YesEdge,
	noEdge: NoEdge,
};
